import { ReactElement } from "react";
import Checkbox from "@ingka/checkbox";
import "@ingka/svg-icon/dist/style.css";
import "@ingka/forms/dist/style.css";
import "@ingka/focus/dist/style.css";

type FixaCheckboxProps = {
  id: string;
  value: string;
  checked?: boolean;
  onChange?: () => void;
  label?: string | ReactElement;
  indeterminate?: boolean;
  subtle?: boolean;
  readOnly?: boolean;
  disabled?: boolean;
  "data-testid"?: string;
  className?: string;
};

function FixaCheckbox(props: FixaCheckboxProps) {
  return <Checkbox {...props} />;
}

export default FixaCheckbox;
